import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Select,
  Textarea,
} from '@chakra-ui/react';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTurma } from 'contexts/turma';

const schema = Yup.object().shape({
  valido: Yup.string().required('Um opção deve ser selecionada!'),
  motivo_invalido: Yup.string().when('valido', {
    is: (value) => value === 'nao',
    then: Yup.string().required(
      'Um motivo é requerido quando o arquivo é inválido',
    ),
    otherwise: Yup.string(),
  }),
});

interface IFormInputs {
  valido: string;
  motivo_invalido: string;
}
interface IDocumento {
  dispensado: boolean;
  ext: null;
  filename: null;
  id_documento_turma: number;
  id_inscricao: number;
  motivo_invalido: string;
  valido: boolean;
}

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  documento: IDocumento;
}

const ModalValidaDocumentoDispensado: React.FC<IProps> = ({
  isOpen,
  onClose,
  documento,
}) => {
  const { validaDocumentoDispensado } = useTurma();
  const onSubmit = async (data: any): Promise<void> => {
    try {
      const dadosFormatados = {
        valido: data.valido === 'sim',
        motivo_invalido: data.motivo_invalido,
        id_inscricao: documento.id_inscricao,
        id_documento_turma: documento.id_documento_turma,
      };
      await validaDocumentoDispensado(dadosFormatados);
      onClose();
    } catch (error) {
      onClose();
    }
  };

  const { handleSubmit, errors, register, watch } = useForm<IFormInputs>({
    resolver: yupResolver(schema),
    defaultValues: {
      valido: undefined,
      motivo_invalido: '',
    },
  });

  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size="lg"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Validar Documento</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <form>
            <Flex direction="column">
              <FormControl id="valido" isRequired isInvalid={!!errors.valido}>
                <FormLabel fontSize="0.90rem">Válido?</FormLabel>

                <Select
                  fontSize="0.90rem"
                  name="valido"
                  ref={register}
                  placeholder="Selecione uma opção!"
                >
                  <option value="sim">SIM</option>
                  <option value="nao">NÃO</option>
                </Select>
                <FormErrorMessage>{errors.valido?.message}</FormErrorMessage>
              </FormControl>

              <FormControl
                mt="8px"
                id="motivo_invalido"
                isRequired
                isInvalid={!!errors.motivo_invalido}
              >
                <FormLabel fontSize="0.90rem">Motivo Inválido</FormLabel>

                <Textarea
                  name="motivo_invalido"
                  ref={register}
                  placeholder="Digite o motivo"
                  size="sm"
                  isDisabled={watch('valido') !== 'nao'}
                />
                <FormErrorMessage>
                  {errors.motivo_invalido?.message}
                </FormErrorMessage>
              </FormControl>
            </Flex>
          </form>
        </ModalBody>

        <ModalFooter>
          <Button
            colorScheme="primary"
            mr={3}
            onClick={handleSubmit((data) => onSubmit(data))}
          >
            Salvar
          </Button>
          <Button colorScheme="red" onClick={onClose}>
            Cancelar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalValidaDocumentoDispensado;
